export default {
    
    indexWorkTimeCategories:    { method: 'get',    url: 'work_time_categories' },
    createWorkTimeCategory:     { method: 'post',   url: 'work_time_categories'},
    updateWorkTimeCategory:     { method: 'put',    url: 'work_time_categories/{id}'},
    deleteWorkTimeCategory:     { method: 'delete', url: 'work_time_categories/{id}'},
}